import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (value: string) => {
    localStorage.setItem("cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-card border border-border rounded-xl shadow-2xl w-[90vw] max-w-xl mx-4 p-6 sm:p-8 animate-in zoom-in-95 duration-300">
        <h2 className="text-2xl font-bold font-display text-foreground mb-4">
          This website uses cookies
        </h2>

        <p className="text-sm text-muted-foreground font-body leading-relaxed mb-2">
          We use cookies to personalise content, to provide social media features and to
          analyse our traffic. We also share information about your use of our site with our
          social media, advertising and analytics partners who may combine it with other
          information that you've provided to them or that they've collected from your use of
          their services.
        </p>

        <p className="text-sm text-muted-foreground font-body mb-6">
          For more information read our{" "}
          <Link
            to="/privacy-policy"
            className="text-primary hover:underline font-medium"
          >
            cookie policy
          </Link>
          .
        </p>

        <div className="border-t border-border pt-5 flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => handleConsent("all")}
            className="flex-1 px-5 py-3 text-sm font-semibold bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Allow all cookies
          </button>
          <button
            onClick={() => handleConsent("necessary")}
            className="flex-1 px-5 py-3 text-sm font-semibold border border-primary text-primary rounded-lg hover:bg-primary/10 transition-colors"
          >
            Use necessary cookies only
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
